var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "float-right px-4"
  }, [_c('v-img', {
    attrs: {
      "width": _vm.width,
      "src": _vm.$asset.contentslogo.format(_vm.named.m_TitleType) + '.png'
    }
  })], 1), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Profile')))]), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('p', {
    class: {
      small: _vm.$vuetify.breakpoint.xsOnly
    },
    domProps: {
      "innerHTML": _vm._s(_vm.named.m_ProfileText.replace(/\n/g, '<br>'))
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Nick Name'),
      "v": _vm.$name(_vm.named.m_NickName),
      "width": "33%"
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Full Name'),
      "v": _vm.$name(_vm.named.fullName),
      "width": "33%"
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Gift Type'),
      "v": _vm.$t("Gift Types.".concat(_vm.named.m_DropItemKey)),
      "width": "33%"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }